export function DueChip({ dueAt }: { dueAt: string | null }) {
  if (!dueAt) return null;
  const due = new Date(dueAt);
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.floor((due.getTime() - midnight.getTime()) / 86_400_000);

  let label = '';
  let cls = '';
  if (diffDays < 0) {
    const days = Math.abs(diffDays);
    label = days === 1 ? '1d overdue' : `${days}d overdue`;
    cls = 'chip chip-critical';
  } else if (diffDays === 0) {
    label = 'due today';
    cls = 'chip chip-high';
  } else if (diffDays === 1) {
    label = 'due tomorrow';
    cls = 'chip chip-medium';
  } else if (diffDays <= 7) {
    label = `in ${diffDays}d`;
    cls = 'chip chip-medium';
  } else {
    label = due.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    cls = 'chip chip-low';
  }

  return (
    <span className={cls} title={due.toLocaleString()}>
      {label}
    </span>
  );
}

export function formatDueInputValue(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function parseDueInputValue(v: string): string | null {
  if (!v) return null;
  const d = new Date(`${v}T23:59:00`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
